export abstract class AbstractBaseLayerState {
  readonly type!: string;

  constructor(
    public width: number,
    public height: number,
  ) {}
}
